module.exports = new Promise((resolve, reject) => {
    import('/remoteEntry.js').then(resolve).catch(reject);
  });